import { type ReactNode } from 'react'

type Props = {
  label: string
  htmlFor: string
  help?: string
  error?: string
  children: ReactNode
  required?: boolean
}

export default function Field({ label, htmlFor, help, error, children, required }: Props) {
  return (
    <div className="mb-5">
      <label className="label" htmlFor={htmlFor}>
        {label}
        {required && <span className="text-terracottaDark"> *</span>}
      </label>
      {children}
      {help && !error && <p className="help">{help}</p>}
      {error && <p className="err" role="alert">{error}</p>}
    </div>
  )
}
